/** Created by azhou on 2019/3/12.*/
<template>
  <div>
    <!-- <group-store-lists v-if="showStoreLists"/> -->
    <store-index /> 
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import StoreIndex from './Index'
  import GroupStoreLists from './GroupStoreLists'

  export default {
    name: 'GroupBasicBus',
    components: {GroupStoreLists, StoreIndex},
    computed: {
      ...mapState(['currentStoreInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
      showStoreLists() {
        return this.isGroup && !this.$route.query.store && this.$route.query.type !== 'add'
      }
    }
  }
</script>
